import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import _ from 'lodash'
// import * as actions from './actions'
// import * as getters from './getters'

import hub from './modules/hub'
import options from './modules/options'
import pages from './modules/pages'
import list from './modules/list'
import guide from './modules/guide'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  // actions,
  // getters,
  modules: {
    hub,
    options,
    pages,
    list,
    guide,
  },
  strict: debug,
  plugins: [
    createPersistedState({
      reducer: (persistedState) => {
        const stateFilter = Object.assign({}, persistedState)
        const blackList = [
          // 'hub.loading_progress',
          // 'options.isAudioPlaying',
          // 'guide.showGuide',
        ]

        blackList.forEach((item) => {
          // delete stateFilter[item]
          _.unset(stateFilter, item);
        })

        return stateFilter
      }
    })
  ]
})
